import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Subsititute as credenciais abaixo pelas do seu projeto no Console do Firebase
// https://console.firebase.google.com/
const firebaseConfig = {
    apiKey: "AIzaSyD5by0BB4m_HdUpotKKE22JZ7BiaVGPTXM",
    authDomain: "barberia-9b5b6.firebaseapp.com",
    projectId: "barberia-9b5b6",
    storageBucket: "barberia-9b5b6.firebasestorage.app",
    messagingSenderId: "355799995930",
    appId: "1:355799995930:web:8f07ecd0d8b3bf735fa3a3",
    measurementId: "G-Z7YWH8JP8T"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;
